<template>
<div class="chapter">
<div class="inner_page">
<div id="d61713422e59b-d1e253"><span id="pageiii">
<h1 class="book-title">FRIENDS IN HIGH PLACES</h1>
<h2 class="book-subtitle">A Liberty Lane Mystery</h2>
<h2 class="book-author">Caro Peacock</h2>
<p class="publisher-logo"><span class="image-centered" id="imgd1e949"><img alt="" src="OEBPS/images/9781780106601_epub_002.jpg"/></span></p></span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781780106601_epub_tp.vue?3f0fc750